module.exports = __webpack_public_path__ + "static/404-3fe71ca3790d556eb0b1a1becb071536.jpg";